var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-pagination',{attrs:{"current-page":_vm.queryInfo.pagenum,"page-sizes":[1, 2, 5, 10],"page-size":_vm.queryInfo.pagesize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }